<template>
	<div class="err"><p class="err-msg" v-if="err">{{err}} <span class="reload-link" v-on:click="reload">Reload Page</span></p></div>
</template>
<script>
	export default {
		name: 'error',
		computed: {
			err () {
				return this.$store.state.dataError
			}
		},
		methods: {
			reload (event) {
				event.preventDefault()
				location.reload()
			}
		}
	}
</script>
<style>
.err{
	background-color: #d9534f
}
.err-msg{
	text-align: center;
	padding: 10px;
	color: #ffffff;
}
.reload-link{
	text-decoration: underline;
	cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// error.vue?4978e46d